import React from 'react';
import ModalBasic from '../../../../pages/component/ModalBasic';
import ValidationText from '../../../../utils/validation/ValidationText';
import TextInput from '../../../UIComponent/TextInput';
import DatePicker from '../../../datePicker/DatePicker';
import moment from 'moment';

function AddEditDirector(props) {
    const getFieldValue = (field) => {
        return props.editingProject?.[field] ?? props.newProject?.[field] ?? '';
    };

    return (
        <ModalBasic
            id="show-add-edit-person-modal"
            modalOpen={props.modalOpen}
            setModalOpen={props.setModalOpen}
            title={props.editingProject ? 'Edit Director' : 'Add Director'}
        >  
          <div className="w-full flex justify-center items-center min-h-[200px]">
                <div className="modal-popup">
                    <div className="">
                        {/* <div className="flex justify-between items-center mb-4">
                            <h1 className="text-xl font-bold text-gray-800">
                                {props.editingProject ? 'Edit Director' : 'Add Director'}
                            </h1>
                            <button onClick={props.closeModal} className="text-xl font-semibold leading-none">×</button>
                        </div> */}

                        {/* Name */}
                        <div className="mb-3">
                            <label className="input-title mb-3">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <TextInput
                                name="name"
                                value={getFieldValue('name')}
                                handleChange={(e) => props.handleChange('name', e.target.value)}
                                className="w-full border border-gray-300 rounded-md p-2"
                            />
                            <ValidationText error={props.validState.error.name} />
                        </div>

                        {/* NRIC */}
                        <div className="mb-3">
                            <label className="input-title mb-3">
                                NRIC/FIN/Passport <span className="text-red-500">*</span>
                            </label>
                            <TextInput
                                name="nRIC_FIN_Passport"
                                value={getFieldValue('nRIC_FIN_Passport')}
                                handleChange={(e) => props.handleChange('nRIC_FIN_Passport', e.target.value)}
                                className="w-full border border-gray-300 rounded-md p-2"
                            />
                            <ValidationText error={props.validState.error.nRIC_FIN_Passport} />
                        </div>

                        {/* Appointment Date */}
                        <div className="mb-3">
                            <label className="input-title mb-3">
                                Date of Appointment <span className="text-red-500">*</span>
                            </label>
                            <DatePicker
                                name="dateofAppoitment"
                                value={
                                    getFieldValue('dateofAppoitment')
                                        ? moment(getFieldValue('dateofAppoitment')).format('YYYY-MM-DD')
                                        : ''
                                }
                                handleChange={(e) => props.handleChange('dateofAppoitment', e.target.value)}
                            />
                            <ValidationText error={props.validState.error.dateofAppoitment} />
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-between mt-5">
                            <button
                                type="button"
                                onClick={props.closeModal}
                                className="px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-100"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={() => props.handleSave(props.editingProject?.id ?? null)}
                                className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
                            >
                                {props.editingProject ? 'Save Changes' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBasic>


    );
}

export default AddEditDirector;
